// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3Jkae","cell":"ColumnAccessor_cell__YD6b8","firstCellAccent":"ColumnAccessor_firstCellAccent__--xLm"};